import { jsx } from "react/jsx-runtime";
import { Box as MUIBox } from "@mui/material";
import { forwardRef } from "react";
const BoxInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIBox,
    {
      ...restProps,
      ref
    }
  );
};
const Box = forwardRef(BoxInner);
export {
  Box
};
